import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  oneData: null,
};

export const testimonialSlice = createSlice({
  name: 'testimonial',
  initialState,
  reducers: {
    getTestimonials: (state) => {
      state.loading = true;
    },
    addTestimonial: (state) => {
      state.loading = true;
    },
    updateTestimonial: (state) => {
      state.loading = true;
    },
    removeTestimonial: (state) => {
      state.loading = true;
    },
    getOneTestimonial: (state) => {
      state.loading = true;
    },
    successTestimonial: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    successOneTestimonial: (state, action) => {
      state.loading = false;
      state.oneData = action.payload;
    },
    failedTestimonial: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getTestimonials,
  addTestimonial,
  updateTestimonial,
  removeTestimonial,
  getOneTestimonial,
  successTestimonial,
  successOneTestimonial,
  failedTestimonial,
} = testimonialSlice.actions;

export default testimonialSlice.reducer;
